import React from "react";
import { Divider, Grid, Typography } from "@mui/material";
import { InputField } from "../../../../utils/FormFields";

export default function PatientBody(props: any) {
  return (
    <>
      <Typography variant="h5" gutterBottom sx={{ p: 0 }}>
        Patient Body
      </Typography>
      <Divider />
      <Grid container rowSpacing={4} spacing={2} sx={{pt:4, justifyContent: "center", alignContent: "center" }}>
        <Grid item xs={12} sm={3}>
          <InputField name="Patient.Weight" label="Weight" type="number" suffix="kg" fullWidth />
        </Grid>
        <Grid container />
        <Grid item xs={12} sm={3}>
          <InputField name="Patient.Height" label="Height" type="number" suffix="cm" fullWidth />
        </Grid>
      </Grid>
    </>
  );
}
